module.exports = __webpack_public_path__ + "files/a893ca31f6e11effd7dc40088b38beac.svg";